import { useCallback } from "react";
import { Shared_ContactPersonPermissionKinds } from "src/backend/openapi/v1";
import { useContactPersonPermissionsT } from "src/translation-hooks/contact-person-permissions";
import { enumToObject } from "src/utils";

export const usePermissionsTranslation = () => {
  const contactPersonPermissionsT = useContactPersonPermissionsT();

  const getPermissionTranslation = useCallback(
    (state: Shared_ContactPersonPermissionKinds) => {
      switch (state) {
        case Shared_ContactPersonPermissionKinds.ManageOtherPublicUser:
          return contactPersonPermissionsT.manageOtherPublicUser;
        case Shared_ContactPersonPermissionKinds.ViewInvoice:
          return contactPersonPermissionsT.viewInvoice;
        case Shared_ContactPersonPermissionKinds.ViewPricelist:
          return contactPersonPermissionsT.viewPriceList;
        case Shared_ContactPersonPermissionKinds.ViewProjects:
          return contactPersonPermissionsT.viewProjects;
        case Shared_ContactPersonPermissionKinds.ShowDekoSupportLink:
          return contactPersonPermissionsT.showDekoSupportLink;
        case Shared_ContactPersonPermissionKinds.ShowPictureStoreLink:
          return contactPersonPermissionsT.showPictureStoreLink;

        default:
          const assertNever = state;
          return assertNever;
      }
    },
    [contactPersonPermissionsT]
  );
  return { getPermissionTranslation };
};

export const getContactPersonPermissions = () => {
  const data = enumToObject<Shared_ContactPersonPermissionKinds>(Shared_ContactPersonPermissionKinds);

  Object.entries(data).forEach(([key, value]) => {
    if (
      // add enum value here if you dont want to show that permission in UI
      [Shared_ContactPersonPermissionKinds.ViewProjects, Shared_ContactPersonPermissionKinds.ShowDekoSupportLink, Shared_ContactPersonPermissionKinds.ShowPictureStoreLink].includes(
        value as Shared_ContactPersonPermissionKinds
      )
    ) {
      delete data[key];
    }
  });
  return data;
};
